module.exports = __webpack_public_path__ + "img/qj.908bd744.png";